import HttpService from "./HttpService";
import { api } from "../common/enviroment";

export default class StockTotalService {
  httpService = new HttpService();

  getAll = (productIds) => {
    // Convertir array de productIds a query parameters
    const queryParams = productIds && productIds.length > 0 
      ? productIds.map(id => `productId=${id}`).join('&')
      : '';

    return this.httpService.get(
      `/services/app${api.STOCK_TOTAL_SERVICE}/GetAll${queryParams ? '?' + queryParams : ''}`
    );
  };

  updateCost = (data) => {
    return this.httpService.put(
      `/services/app${api.STOCK_TOTAL_SERVICE}/UpdateCost`,
      data
    );
  };
}